<template>
  <div>
    <router-view v-if="this.$route.path!=='/operationManage/customerManage'" :getEmployeeListData.sync="getEmployeeListData"></router-view>
    <div v-else class="customerManage">
      <!-- 添加/修改备注 -->
      <div class="operationNotes">
        <el-dialog :title="operationNotesTitle" :visible.sync="operationNotesVisible" :close-on-click-modal="false">
          <el-form ref="operationNotesForm" :model="operationNotesForm" :rules="operationNotesRules">
            <el-form-item label="" prop="content">
              <p v-if="viewContentVisible">{{operationNotesForm.content}}</p>
              <el-input v-else type="textarea" :rows="3" v-model="operationNotesForm.content" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="operationNotesVisible=false">取 消</el-button>
              <el-button v-if="viewContentVisible" size="small" type="primary" @click="operationNotesVisible=false">确 定</el-button>
              <el-button v-else size="small" type="primary" @click="operationNotesSubmit('operationNotesForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 修改有效期 -->
      <div class="modifyValidPeriod">
        <el-dialog title="修改有效期" :visible.sync="modifyValidPeriodVisible" :close-on-click-modal="false">
          <el-form ref="modifyValidPeriodForm" :model="modifyValidPeriodForm" :rules="modifyValidPeriodRules">
            <el-form-item label="" prop="date">
              <el-date-picker
                v-model="modifyValidPeriodForm.date"
                :picker-options="pickerOptions"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="btn">
              <el-button size="small" @click="modifyValidPeriodVisible=false">取 消</el-button>
              <el-button size="small" type="primary" v-if="enterpriseVaildPeriodPermission" @click="modifyValidPeriodSubmit('modifyValidPeriodForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 查看/修改权限 -->
      <div class="modifyPermissions">
        <el-dialog :title="modifyPermissionsTitle" :visible.sync="modifyPermissionsVisible" :close-on-click-modal="false">
          <el-form ref="modifyPermissionsForm" :model="modifyPermissionsForm" :rules="modifyPermissionsRules" label-width="120px">
            <el-form-item label="公司名称：">
              {{modifyPermissionsForm.name}}
            </el-form-item>
            <el-form-item label="权限模块：" prop="list">
              <el-checkbox-group  v-for="item in permissionsList" :key="item.id" v-model="modifyPermissionsForm.list">
                <el-checkbox :label="item.moduleName" :disabled="modifyPermissionsTitle==='查看权限'||item.moduleName==='A（基础权限）'"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="btn" v-if="modifyPermissionsTitle!=='查看权限'">
              <el-button size="small" @click="modifyPermissionsVisible=false">取 消</el-button>
              <el-button size="small" type="primary" @click="operationPermissionSubmit('modifyPermissionsForm')">确 定</el-button>
            </el-form-item>
            <el-form-item v-else></el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 添加/查看自运营账户 -->
      <el-drawer title="自运营账户授权" :visible.sync="opSelfAccountVisible" :wrapperClosable="false" size="800px" :destroy-on-close="true" class="opSelfAccount">
        <el-form label-width="130px" :model="opSelfAccountForm" :rules="opSelfAccountRules" ref="opSelfAccountRef" class="top-form">
          <el-form-item label="公司名称：" style="margin-bottom:10px;">{{opSelfAccountName}}</el-form-item>
          <el-form-item label="自运营账户ID：" prop="accountIds">
            <el-input type="textarea" rows="6" v-model="opSelfAccountForm.accountIds" @input="inputSelfAccount($event)" placeholder="多个请用英文逗号“,”隔开，不能有空格"></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-bottom:10px;" class="btn-box">
            <el-upload class="upload-btn"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            action="" :file-list="opSelfAccountForm.uploadFile"
            :before-upload="beforeUpload">
              <el-button size="medium" type="primary" :loading="btnLoading">导入excel</el-button>
            </el-upload>
            <el-button size="medium" type="primary" @click="opSelfAccountSubmit()" :loading="opSelfAccountBtnLoading" class="addBtn">添加</el-button>
          </el-form-item>
        </el-form>
        <div class="item-line"></div>
        <!-- 列表 -->
        <div class="top-form">
          <p class="comName">公司名称：{{opSelfAccountName}}</p>
          <el-select class="selectStatus" v-model="opSelfAccountForm.authorizationStatus" placeholder="请选择授权状态" size="medium" @change="searopSelfAccount" clearable>
            <el-option label="已授权" :value="1"></el-option>
            <el-option label="未授权" :value="2"></el-option>
          </el-select>
          <el-input
            size="medium"
            class="inline-input"
            v-model="opSelfAccountForm.searchName"
            placeholder="请输入账户ID/名称"
            >
          </el-input>
          <el-button type="primary" @click="searopSelfAccount()" size="medium">搜索</el-button>
          <el-button type="primary" @click="searopSelfAccount()" size="medium">刷新</el-button>
          <el-button @click="clearAcc()" :disabled="multipleSelection.length === 0" size="medium">清除账户</el-button>
        </div>
        <div class="choose-box">
          <el-table class="minitable" :data="selfAccountList" border @selection-change="handleSelectionChange" v-loading="selfAccountListLoading" :max-height="selfAccountListHeight">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="agentAccountId" label="账户ID" width="240"></el-table-column>
            <el-table-column prop="agentAccountName" label="账户名称"> </el-table-column>
            <el-table-column prop="subTime" label="录入时间"> </el-table-column>
          </el-table>
        </div>
        <div class="desc">
          <span>总账户数：{{selfAccountList.length}}&nbsp;&nbsp;&nbsp;已选账户数：{{multipleSelection.length}}</span>
        </div>
        <!-- bottom -->
        <!-- <div class="btn">
          <el-button size="small" @click="opSelfAccountVisible=false">取 消</el-button>
          <el-button size="small" type="primary" @click="opSelfAccountVisible=false">确 定</el-button>
        </div> -->
      </el-drawer>
      <!-- end -->
      <div class="top clearFix">
        <div class="page-title top0">客户管理</div>
        <el-form :inline="true" class="form" label-width="100px">
          <el-form-item label="公司名称">
            <el-input v-model="filterParam.companyName" @blur="getEnterpriseList(1, pagesize)" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名">
            <el-input style="width:150px" v-model="filterParam.contactName" @blur="getEnterpriseList(1, pagesize)" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input style="width:150px" v-model="filterParam.phone" @blur="getEnterpriseList(1, pagesize)" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="账户状态">
            <el-select style="width:160px" v-model="filterParam.status" placeholder="请选择账户状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="待审核" value="0"></el-option>
              <el-option label="已开通" value="1"></el-option>
              <el-option label="已关闭" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableBox" v-if="enterpriseListPermission">
        <el-table class="roleTable" :data="enterpriseList" border>
          <el-table-column prop="id" label="公司ID" fixed></el-table-column>
          <el-table-column prop="enterpriseName" label="公司名称" fixed min-width="200"></el-table-column>
          <el-table-column prop="enterpriseContact" label="联系人姓名" fixed min-width="120"></el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="140"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status===0" class="blue">待审核</span>
              <span v-else-if="scope.row.status===1" class="green">已开通</span>
              <span v-else-if="scope.row.status===2" class="red">已关闭</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="enterpriseOpenPermission">
            <template slot-scope="scope">
              <el-switch @change="switchChange(scope.row.operation,scope.row.id)" v-model="scope.row.operation"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="注册时间" min-width="120"></el-table-column>
          <el-table-column label="有效期" min-width="120">
            <template slot-scope="scope">
              <div class="edit">
                {{scope.row.vaildPeriod}}
                <el-tooltip content="修改" placement="top" v-if="enterpriseVaildPeriodPermission">
                  <i @click="modifyValidPeriod(scope.row.id,scope.row.vaildPeriod)" class="iconfont icon-edit"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="已开通员工账号" min-width="120">
            <template slot-scope="scope">
              <div class="operating">
                <div v-if="scope.row.employeeNum>0">
                  {{scope.row.employeeNum}}
                  <span v-if="employeeListPermission" @click="ViewAccount(scope.row.id,scope.row.enterpriseName)">查看</span>
                </div>
                <div v-else>无</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="账号权限" min-width="120" fixed>
            <template slot-scope="scope">
              <div class="operating">
                  <span v-if="authorityModulePermission" @click="operationPermission(scope.row)">查看</span>
                  <span v-if="authorityModuleEditPermission" @click="operationPermission(scope.row,'change')">修改</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="120" v-if="enterpriseCommentPermission">
            <template slot-scope="scope">
              <div class="operating">
                <span v-if="scope.row.comment==''">
                  <span @click="operationNotes('add',scope.row.id)">添加</span>
                </span>
                <span v-else>
                  <span @click="operationNotes('view',scope.row.id,scope.row.comment)">查看</span>
                  <span @click="operationNotes('edit',scope.row.id,scope.row.comment)">修改</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="自运营账户" min-width="120" fixed>
            <template slot-scope="scope">
              <div class="operating">
                <!-- <span @click="opSelfAccount('add',scope.row)">添加</span>
                <span @click="opSelfAccount('view',scope.row)">查看</span> -->
                <span @click="opSelfAccount('',scope.row)">授权</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging-box" v-if="pageTotal>0">
          <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[ 10, 20, 40, 80, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 表单验证
import { notNullable } from '@/components/form/formValidation'
// 公用
import { getTime } from '@/components/public'

export default {
  name: 'customerManage',
  data () {
    // 重复密码验证
    const selfAccountIdInput = async (rule, value, callback) => {
      if (value !== '' && value.split(',').indexOf('') !== -1) {
        return callback(new Error('格式错误，无法保存'))
      } else {
        let status = true
        const arr = value.split(',')
        const dataReg = /^([0-9]{6,16})(,[0-9]{6,16})*$/
        arr.forEach(item => {
          if (!dataReg.test(item)) {
            status = false
          }
        })
        // console.log(arr)
        if (!status) {
          return callback(new Error('账户ID格式有误'))
        } else {
          callback()
        }
      }
    }
    return {
      btnLoading: false,
      multipleSelection: [],
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      // 筛选条件参数
      filterParam: {
        companyName: '',
        contactName: '',
        phone: '',
        status: ''
      },
      // 客户列表
      enterpriseList: [],
      enterpriseListParam: {},
      getEmployeeListData: {
        id: 0,
        enterpriseName: ''
      },
      // 添加/修改备注
      operationNotesTitle: '',
      operationNotesType: '',
      operationNotesid: '',
      operationNotesParam: {},
      operationNotesVisible: false,
      viewContentVisible: false,
      operationNotesForm: {
        content: ''
      },
      operationNotesRules: {
        content: [
          notNullable('请填写备注信息')
        ]
      },
      // 修改账户有效期
      modifyValidPeriodId: '',
      modifyValidPeriodParam: {},
      modifyValidPeriodVisible: false,
      modifyValidPeriodForm: {
        date: ''
      },
      modifyValidPeriodRules: {
        date: [
          notNullable('请选择有效期')
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      // 修改权限
      modifyPermissionsVisible: false,
      modifyPermissionsTitle: '',
      modifyPermissionsForm: {
        id: 0,
        name: '',
        list: ['A（基础权限）']
      },
      modifyPermissionsRules: {
        list: [
          notNullable('请选择要分配的权限')
        ]
      },
      permissionsList: [],
      // 接口权限显示相关
      enterpriseListPermission: false,
      enterpriseVaildPeriodPermission: false,
      enterpriseOpenPermission: false,
      employeeListPermission: false,
      enterpriseCommentPermission: false,
      authorityModulePermission: false,
      authorityModuleEditPermission: false,
      opSelfAccountId: 0,
      opSelfAccountName: '',
      opSelfAccountRow: null,
      opSelfAccountVisible: false,
      opSelfAccountBtnLoading: false,
      opSelfAccountRules: {
        accountIds: [
          notNullable('请输入自运营账户ID'),
          { required: true, validator: selfAccountIdInput, trigger: ['blur', 'change'] }
        ]
      },
      opSelfAccountForm: {
        accountIds: '',
        searchName: '',
        authorizationStatus: '',
        uploadFile: []
      },
      selfAccountList: [],
      selfAccountListHeight: '',
      selfAccountListLoading: false
    }
  },
  created () {
    this.selfAccountListHeight = document.documentElement.clientHeight - 560 > 210 ? document.documentElement.clientHeight - 560 : 210
  },
  mounted () {
    if (this.$route.path === '/operationManage/customerManage') {
      // 获取客户列表
      this.getEnterpriseList(this.currentPage, this.pagesize)
      // 获取可选权限列表
      // if (this.checkPermission('role:authorityModule:all')) {
      this.getPermissionsList()
      // }
    }
    this.enterpriseListPermission = this.checkPermission('enterprise:list')
    this.enterpriseVaildPeriodPermission = this.checkPermission('enterprise:vaildPeriod')
    this.enterpriseOpenPermission = this.checkPermission('enterprise:open')
    this.employeeListPermission = this.checkPermission('enterprise:employee:list')
    this.enterpriseCommentPermission = this.checkPermission('enterprise:comment')
    this.authorityModulePermission = this.checkPermission('role:authorityModule')
    this.authorityModuleEditPermission = this.checkPermission('role:authorityModule:edit:list')
  },
  watch: {
    // 监测下拉框内容更新 更新投放账户列表
    'filterParam.status': {
      deep: true,
      handler: function (newV, oldV) {
        this.getEnterpriseList(1, this.pagesize)
      }
    },
    // 监测弹窗
    operationNotesVisible (to, form) {
      if (to === false) {
        // 清空表单
        this.resetForm('operationNotesForm')
        this.operationNotesForm.content = ''
        this.viewContentVisible = false
      }
    },
    modifyValidPeriodVisible (to, form) {
      if (to === false) {
        // 清空表单
        this.resetForm('modifyValidPeriodForm')
        this.modifyValidPeriodForm.date = ''
        this.modifyValidPeriodVisible = false
      }
    },
    modifyPermissionsVisible (to, form) {
      if (to === false) {
        // 清空表单
        this.resetForm('modifyPermissionsForm')
      }
    },
    $route (to) {
      if (this.$route.path === '/operationManage/customerManage') {
      // 获取企业列表
        this.getEnterpriseList(this.currentPage, this.pagesize)
      }
    },
    opSelfAccountVisible(to) {
      if (!to) {
        this.opSelfAccountForm.accountIds = ''
        this.opSelfAccountForm.uploadFile = []
      }
    }
  },
  methods: {
    clearAcc() {
      this.$confirm('确认清除已选账户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let authIds = this.multipleSelection.map(item => {
          this.opSelfAccountRow.authIds = this.opSelfAccountRow.authIds.replace(item.id + ',', '').replace(item.id, '')
          return item.id
        })
        let params = {
          enterpriseId: this.opSelfAccountRow.id,
          idList: authIds
        }
        this.$service.post('/api/enterprise/agent/account/delete', params).then(res => {
          // 删除
          if (res.code === 200) {
            this.$message.success('清除成功')
            this.searopSelfAccount()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },
    // 上传数据校验
    beforeUpload (file) {
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      // const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      if (!extension2) {
        this.$message.error('上传文件只能是 xlsx格式!')
      }
      if (extension2) {
        this.opSelfAccountForm.uploadFile = []
        this.opSelfAccountForm.uploadFile.push(file)
        this.upload()
        return false // 取消默认上传
      }
    },
    upload() {
      console.log('upload')
      this.btnLoading = true
      const fileFormData = new FormData()
      if (this.opSelfAccountForm.uploadFile.length !== 0) {
        fileFormData.append('file', this.opSelfAccountForm.uploadFile[0], this.opSelfAccountForm.uploadFile[0].name)
        // fileFormData.append('flag', this.opSelfAccountForm.flag) // flag: this.opSelfAccountForm.flag,
        fileFormData.append('id', parseInt(this.opSelfAccountId))
      }
      let headers = {
        'Content-Type': 'multipart/form-data' // 设置请求头
      }
      this.$service.post('/api/enterprise/importAuthAccount', fileFormData, {
        headers: headers,
        onUploadProgress: progressEvent => {
          let complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0) + '%'
          console.log(complete)
        }
      }).then(res => {
        if (res.code === 200) {
          // res.result
          if (res.result) {
            this.opSelfAccountForm.accountIds = res.result
          } else {
            this.opSelfAccountForm.uploadFile = []
            this.$message.error('没有可导入的账户')
          }
        } else {
          this.$message.error(res.message)
          this.opSelfAccountForm.uploadFile = []
        }
        this.btnLoading = false
      }).catch(e => {
        this.btnLoading = false
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getEnterpriseList (currentPage, pagesize) {
      // console.log(status)
      // if (status !== '' || status !== undefined) {
      //   this.filterParam.status = status
      // }
      // console.log(this.filterParam.status)
      this.currentPage = currentPage
      this.enterpriseListParam = {
        pageNum: currentPage,
        pagesize: pagesize,
        enterpriseContact: this.filterParam.contactName,
        enterpriseName: this.filterParam.companyName,
        phone: this.filterParam.phone,
        status: this.filterParam.status
      }
      this.$service.post('/api/enterprise/list', this.enterpriseListParam).then(res => {
        res.result.pageData.forEach((item, index) => {
          if (item.status === 1) {
            item.operation = true
          } else {
            item.operation = false
          }
          item.createTime = getTime(new Date(item.createTime))
          item.vaildPeriod = getTime(new Date(item.vaildPeriod))
        })
        this.enterpriseList = res.result.pageData
        this.pageTotal = res.result.total
      }).catch(Err => {
      })
    },
    // 获取选择权限列表
    getPermissionsList() {
      this.$service.post('/api/role/authorityModule/all', {}).then(res => {
        res.result.forEach((item) => {
          if (item.moduleName === 'A（基础权限）  默认权限') {
            item.moduleName = 'A（基础权限）'
          }
        })
        this.permissionsList = res.result
      }).catch(Err => {
      })
    },
    // 管理员状态切换
    switchChange (to, id) {
      // console.log(to)
      if (to === false) {
        this.$service.post('/api/enterprise/close', {
          'id': id
        }).then(res => {
          this.$message({
            message: res.message,
            type: 'success'
          })
          // 刷新列表
          this.getEnterpriseList(this.currentPage, this.pagesize, '')
        }).catch(Err => {
        })
      } else {
        this.$service.post('/api/enterprise/open', {
          'id': id
        }).then(res => {
          this.$message({
            message: res.message,
            type: 'success'
          })
          // 刷新列表
          this.getEnterpriseList(this.currentPage, this.pagesize, '')
        }).catch(Err => {
        })
      }
    },
    // 修改有效期
    modifyValidPeriod (id, value) {
      this.modifyValidPeriodId = id
      this.modifyValidPeriodForm.date = value
      this.modifyValidPeriodVisible = true
    },
    modifyValidPeriodSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 参数
          this.modifyValidPeriodParam = {
            'vaildPeriod': getTime(new Date(this.modifyValidPeriodForm.date)),
            'id': this.modifyValidPeriodId
          }
          this.$service.post('/api/enterprise/vaildPeriod', this.modifyValidPeriodParam).then(res => {
            // console.log(res)
            this.$message({
              message: res.message,
              type: 'success'
            })
            // 刷新列表
            this.getEnterpriseList(this.currentPage, this.pagesize)
            this.modifyValidPeriodVisible = false
          }).catch(Err => {
            console.log(Err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 操作备注
    operationNotes (type, id, value) {
      this.opDepartmentid = id
      if (type === 'add') {
        this.operationNotesTitle = '添加备注'
        this.viewContentVisible = false
      } else {
        this.operationNotesForm.content = value
        if (type === 'edit') {
          this.operationNotesTitle = '修改备注'
          this.viewContentVisible = false
        } else {
          this.operationNotesTitle = '查看备注'
          this.viewContentVisible = true
        }
      }
      this.operationNotesVisible = true
    },
    operationNotesSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 参数
          this.opDepartmentParam = {
            'comment': this.operationNotesForm.content,
            'id': this.opDepartmentid
          }
          this.$service.post('/api/enterprise/comment', this.opDepartmentParam).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            // 刷新列表
            this.getEnterpriseList(this.currentPage, this.pagesize)
            this.operationNotesVisible = false
          }).catch(Err => {
            console.log(Err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    searopSelfAccount() {
      this.getAuthAccount(this.opSelfAccountRow, this.opSelfAccountForm)
    },
    // 操作自运营账户
    opSelfAccount(type, row) {
      console.log('opSelfAccount', type, row)
      this.opSelfAccountRow = row
      this.opSelfAccountName = row.enterpriseName
      this.opSelfAccountId = row.id
      this.getAuthAccount(row, this.opSelfAccountForm)
      this.opSelfAccountVisible = true
    },
    // 获取自运营账户列表
    getAuthAccount(row, form) {
      this.selfAccountListLoading = true
      let params = {
        enterpriseId: row.id
      }
      if (form.searchName) {
        params.searchName = form.searchName
      }
      if (form.authorizationStatus) {
        params.authState = form.authorizationStatus === 1
      }
      this.$service.post('/api/enterprise/agent/account/list', params).then(res => {
        this.selfAccountList = res.result
        setTimeout(() => {
          this.selfAccountListLoading = false
        }, 200)
      }).catch(Err => {
        console.log(Err)
        this.selfAccountListLoading = false
      })
    },
    inputSelfAccount(value) {
      if (value !== '' && value !== undefined) {
        this.opSelfAccountForm.accountIds = value.replaceAll(/[^0-9,]/g, '')
      }
    },
    opSelfAccountSubmit() {
      // 添加账号
      this.$refs['opSelfAccountRef'].validate((valid) => {
        if (valid) {
          this.opSelfAccountBtnLoading = true
          this.$service.post('/api/enterprise/agent/account/add', {
            agentAccountIdStr: this.opSelfAccountForm.accountIds,
            enterpriseId: this.opSelfAccountId
          }).then(res => {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.resetForm('opSelfAccountRef')
            this.opSelfAccountForm = {
              accountIds: '',
              searchName: '',
              authorizationStatus: '',
              uploadFile: []
            }
            this.getAuthAccount(this.opSelfAccountRow, this.opSelfAccountForm)
            this.opSelfAccountBtnLoading = false
            // this.getEnterpriseList(this.currentPage, this.pagesize)
            // this.opSelfAccountVisible = false
          }).catch(Err => {
            console.log(Err)
            this.opSelfAccountBtnLoading = false
            // this.opSelfAccountVisible = false
          })
        }
      })
    },
    // 操作权限
    operationPermission(item, type) {
      this.modifyPermissionsForm.name = item.enterpriseName
      this.modifyPermissionsForm.id = item.id
      if (type === 'change') {
        // 修改权限
        this.modifyPermissionsTitle = '修改权限'
        this.modifyPermissionsForm.list = ['A（基础权限）']
        this.$service.post('api/role/authorityModule/edit/list', {id: item.id}).then(res => {
          res.result.forEach((item) => {
            if (item.pitchOn === 1 && item.moduleName !== 'A（基础权限）  默认权限') {
              this.modifyPermissionsForm.list.push(item.moduleName)
            }
          })
          this.modifyPermissionsVisible = true
        }).catch(Err => {
          console.log(Err)
        })
      } else {
        // 查看权限
        this.modifyPermissionsTitle = '查看权限'
        this.$service.post('/api/role/authorityModule', {id: item.id}).then(res => {
          this.modifyPermissionsForm.list = []
          res.result.forEach((item) => {
            if (item.moduleName !== 'A（基础权限）  默认权限') {
              this.modifyPermissionsForm.list.push(item.moduleName)
            } else {
              this.modifyPermissionsForm.list.push('A（基础权限）')
            }
          })
          this.modifyPermissionsVisible = true
        }).catch(Err => {
          console.log(Err)
        })
      }
      this.modifyPermissionsVisible = true
    },
    // 操作权限提交
    operationPermissionSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let selectIds = []
          this.modifyPermissionsForm.list.forEach((item) => {
            this.permissionsList.forEach((items) => {
              if (item === items.moduleName) {
                selectIds.push(items.id)
              }
            })
          })
          let param = {
            authorityModuleId: selectIds,
            enterpriseId: this.modifyPermissionsForm.id
          }
          this.$service.post('/api/role/authorityModule/edit', param).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            // 刷新列表
            this.getEnterpriseList(this.currentPage, this.pagesize)
            this.modifyPermissionsVisible = false
          }).catch(Err => {
            console.log(Err)
          })
        }
      })
    },
    // 查看员工账号
    ViewAccount (id, name) {
      this.getEmployeeListData.id = id
      this.getEmployeeListData.enterpriseName = name
      this.$router.push('/operationManage/customerManage/employeeList')
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.pagesize = size
      this.getEnterpriseList(this.currentPage, size)
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getEnterpriseList(currentPage, this.pagesize)
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }

}
</script>

<style lang="less">
  @import './../../styles/operationManage/customerManage.less';
</style>



// WEBPACK FOOTER //
// src/views/operationManage/customerManage.vue